<template>
  <div class="page padding">
    <b-row>
      <b-col md="6" lg="3" style="">
        <b-card text-variant="white" @click="openPDF('Combinado Familiar.pdf')" :img-src="'img/icons/PATRIMONIAL/Combinado-Familiar_3.1.svg'" title="Combinado Familiar" class="card"> </b-card>
      </b-col>
      <b-col md="6" lg="3" style="">
        <b-card text-variant="white" @click="openPDF('Consultorio.pdf')" :img-src="'img/icons/PATRIMONIAL/Integral-Consultorio_3.2.svg'" title="Integral Consultorio" class="card"> </b-card>
      </b-col>
      <b-col md="6" lg="3" style="">
        <b-card text-variant="white" @click="openPDF('Incendio.pdf')" :img-src="'img/icons/PATRIMONIAL/Incendio_3.3.svg'" title="Incendio" class="card"> </b-card>
      </b-col>
      <b-col md="6" lg="3" style="">
        <b-card text-variant="white" @click="openPDF('Seguro Técnico Equipos Electrónicos.pdf')" :img-src="'img/icons/PATRIMONIAL/Seguro-Tecnico_3.4.svg'" title="Seguro Tecnico" class="card">
        </b-card>
      </b-col>
      <b-col md="6" lg="3" style="">
        <b-card text-variant="white" @click="openPDF('Consorcio.pdf')" :img-src="'img/icons/PATRIMONIAL/Integral-de-Consorcio _3.5.svg'" title="Integral de Consorcio" class="card"> </b-card>
      </b-col>
      <b-col md="6" lg="3" style="">
        <b-card text-variant="white" @click="openPDF('Consultorio.pdf')" :img-src="'img/icons/PATRIMONIAL/Integral-de-Comercio_3.6.svg'" title="Integral de Comercio" class="card"> </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    openPDF(pdf) {
      var url_pdf = 'http://nobleonline.nobleseguros.com/be/recursos/PATRIMONIALES/';
      window.open(url_pdf + pdf);
    },
  },
};
</script>

<style scoped>
.card {
  cursor: pointer;
  background-color: #8976b8;
  text-align: center;
  font-family: 'Open Sans', sans-serif;
}
.card-img {
  max-width: 40%;
  margin-left: auto;
  margin-right: auto;
}
</style>